import { Controller } from 'stimulus';
import { youtubeVideoId } from '../util';

const VALIDATION_DELAY = 500;

export default class extends Controller {
  static targets = ['sourceRadio', 'urlInput', 'urlError'];

  static values = { previewUrl: String };

  #validityTimeout;

  disconnect() {
    clearTimeout(this.#validityTimeout);
  }

  // Point the preview modal, which ui--twin-turbo-modal-trigger#open shows next, at the
  // card's current unsaved source/URL. The embed id fallback is resolved server-side.
  preview(event) {
    const url = new URL(this.previewUrlValue, window.location.origin);
    url.searchParams.set('welcome_video_source', this.customSelected ? 'custom' : 'default');
    if (this.customSelected) {
      url.searchParams.set('welcome_video_url', this.urlInputTarget.value);
    }

    event.currentTarget.setAttribute('data-ui--twin-turbo-modal-trigger-url-value', url);
  }

  sourceChanged() {
    this.flagInvalid(false);
    clearTimeout(this.#validityTimeout);
  }

  urlChanged() {
    this.flagInvalid(false);
    clearTimeout(this.#validityTimeout);
    this.#validityTimeout = setTimeout(() => this.refreshValidity(), VALIDATION_DELAY);
  }

  // Flag the URL input when Custom is selected but the value is blank or not a
  // YouTube video URL; aria-invalid carries the error styling.
  refreshValidity() {
    this.flagInvalid(this.customSelected && !youtubeVideoId(this.urlInputTarget.value));
  }

  flagInvalid(invalid) {
    if (invalid) {
      this.urlInputTarget.setAttribute('aria-invalid', 'true');
      this.urlInputTarget.setAttribute('aria-describedby', this.urlErrorTarget.id);
    } else {
      this.urlInputTarget.removeAttribute('aria-invalid');
      this.urlInputTarget.removeAttribute('aria-describedby');
    }
    this.urlErrorTarget.classList.toggle('hidden', !invalid);
    this.element.dataset.dirtyFormBlockedValue = invalid;
  }

  get customSelected() {
    const checked = this.sourceRadioTargets.find((radio) => radio.checked);
    return checked?.value === 'custom';
  }
}
